import React, { useEffect, useRef, useState } from "react";
import send_icon from "../../assets/img/send_icon.svg";
import add_circle from "../../assets/img/add_circle.svg";
import ai_icon_new from "../../assets/img/ai_icon_color.svg";
import copy_icon from "../../assets/img/copy_icon.svg";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getChatHistory } from "../../redux/GetChatHistorySlice";
import { askQuestionFromPdf } from "../../redux/AskQuestionFromPdfSlice";
import { getProjectList } from "../../redux/GetProjectListSlice";
import PdfFileUpload from "../PdfFileUpload/PdfFileUpload";
import { ApiBaseUrl } from "../../utils/Constants";
import PdfViewer from "../PdfViewer/PdfViewerNew";
import Header from "../Header/Header";
import { clearQuestinDetailData } from "../../redux/GetQuestionDetailsSlice";
import FormatResponse, { DisclaimerIcon } from "./FormatResponse";
import moment from "moment";
import QuickAssessPanel from "../QuickAssess/QuickAssessPanel";
import "../QuickAssess/QuickAssessPanel.scss";
import {
  submitClinicalReview,
  clearClinicalReview,
  getReviewsByProject,
} from "../../redux/clinicalReviewSlice";
import ClinicalOutputPanel from "../ClinicalOutput/ClinicalOutputPanel";

function YourAi() {
  const chatContainerRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();

  const [projectId, setProjectId] = useState("");
  const [chatData, setChatData] = useState([]);
  const [question, setQuestion] = useState("");
  const [question1, setQuestion1] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [currentProject, setCurrentProject] = useState(null);
  const [isProdjectWithPdf, setIsProdjectWithPdf] = useState(false);
  const [pdfListinCurrentProject, setPdfListinCurrentProject] = useState([]);
  const [selectedPdfId, setSelectedPdfId] = useState("all");
  const [showOptionList, setShowOptionList] = useState(false);
  const [isPdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [currentPdfContext, setCurrentPdfContext] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("assess");

  const {
    isSubmitting,
    isLoading: isClinicalLoading,
    currentReview,
    clinicalOutput,
    reviewStatus,
    nextSteps,
  } = useSelector((state) => state.clinicalReview);

  const chatResponse = useSelector((state) => state.chatHistoryReducer.data);
  const questionResponseFromPdf = useSelector((state) => state.askQuestionFromPdfReducer.data);
  const projectResponse = useSelector((state) => state.getProjectListReducer.data);

  useEffect(() => {
    dispatch(getProjectList());
  }, []);

  useEffect(() => {
    if (location.state != null) {
      const { projectId: pid, documentId } = location.state;
      if (pid) setProjectId(pid);
      if (documentId) setSelectedPdfId(documentId);
    }
    dispatch(getProjectList());
  }, [location.state, dispatch]);

  useEffect(() => {
    if (projectResponse?.status === 1) {
      setProjectList(projectResponse.data);
      // Do NOT auto-select the first project — user must choose one explicitly
    }
  }, [projectResponse]);

  useEffect(() => {
    if (projectId) {
      dispatch(clearClinicalReview());
      dispatch(getChatHistory({ id: projectId }));
      dispatch(getReviewsByProject({ projectId }));
    }
  }, [projectId]);

  useEffect(() => {
    if (chatResponse?.status === 1) setChatData(chatResponse.data);
    else setLoading(false);
  }, [chatResponse]);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [chatData, loading]);

  useEffect(() => {
    if (questionResponseFromPdf?.status === 1) {
      const rawData = questionResponseFromPdf.data || {};
      const enriched = {
        ...rawData,
        answerText: questionResponseFromPdf.answerText || rawData.answerText,
        reasoning: questionResponseFromPdf.reasoning || rawData.reasoning,
        followUpQuestions: questionResponseFromPdf.followUpQuestions || rawData.followUpQuestions,
        disclaimer: questionResponseFromPdf.disclaimer || rawData.disclaimer,
        matchingText: questionResponseFromPdf.matchingText || rawData.matchingText,
      };
      setChatData([enriched, ...chatData]);
      setQuestion("");
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [questionResponseFromPdf]);

  useEffect(() => {
    if (projectId) setCurrentProject(projectList.find((p) => p._id === projectId));
  }, [projectId, projectList]);

  useEffect(() => {
    if (currentProject?.ProjectChat) {
      setPdfListinCurrentProject(
        currentProject.ProjectChat.map((i) => ({ id: i._id, pdfName: i.chatName }))
      );
    }
  }, [currentProject]);

  useEffect(() => {
    const lastName = currentProject?.ProjectChat?.[currentProject.ProjectChat.length - 1]?.chatName;
    setIsProdjectWithPdf(!!lastName);
  }, [currentProject]);

  useEffect(() => {
    if (location.state === null && pdfListinCurrentProject.length > 0) {
      setSelectedPdfId(pdfListinCurrentProject[pdfListinCurrentProject.length - 1].id);
    }
  }, [pdfListinCurrentProject]);

  useEffect(() => {
    if (selectedPdfId === undefined && currentProject?.ProjectChat?.length > 0) {
      closePdfViewer();
      setSelectedPdfId(currentProject.ProjectChat[0]._id);
    }
  }, [currentProject]);

  const handleClinicianApprove = ({ reviewId, action }) =>
    dispatch(submitClinicalReview({ reviewId, action }));
  const handleClinicianEdit = ({ reviewId, action, editedOutput }) =>
    dispatch(submitClinicalReview({ reviewId, action, editedOutput }));
  const handleClinicianReject = ({ reviewId, action, clinicianNote }) =>
    dispatch(submitClinicalReview({ reviewId, action, clinicianNote }));

  const onSendMessage = () => {
    if (!question.trim()) return;
    closePdfViewer();
    setLoading(true);
    dispatch(
      askQuestionFromPdf({
        projectId,
        projectChatId: selectedPdfId || "all",
        userQuery: question,
      })
    );
  };

  const handleFollowUpClick = (questionText) => {
    setQuestion(questionText);
    setQuestion1(questionText);
    setTimeout(() => {
      closePdfViewer();
      setLoading(true);
      setQuestion("");
      dispatch(
        askQuestionFromPdf({
          projectId,
          projectChatId: selectedPdfId || "all",
          userQuery: questionText,
        })
      );
    }, 50);
  };

  const handlePdfLinkClick = (pdfUrl, responseText, questionId, dataFromDocs) => {
    setCurrentPdfContext({ pdfUrl, responseText, questionId, dataFromDocs });
    setPdfViewerOpen(true);
  };

  const closePdfViewer = () => {
    dispatch(clearQuestinDetailData());
    setPdfViewerOpen(false);
    setCurrentPdfContext(null);
  };

  const handlePdfUploadSuccess = (newPdf) => {
    setLoading(false);
    dispatch(getProjectList());
    setPdfListinCurrentProject([
      ...pdfListinCurrentProject,
      { id: newPdf._id, pdfName: newPdf.chatName },
    ]);
  };

  const onProjectSelect = (id) => {
    dispatch(clearClinicalReview());
    setProjectId(id);
    closePdfViewer();
  };

  const handleAssessmentComplete = () => {
    if (projectId) dispatch(getReviewsByProject({ projectId }));
  };

  return (
    <div className="sidebar_mar">
      <Header />

      <div className="sidebar_det">
        <div className="flex gap-5 itemcenter">
          <select
            className="project-select"
            value={projectId}
            onChange={(e) => onProjectSelect(e.target.value)}
          >
            <option value="">— Select a project —</option>
            {projectList.map((p) => (
              <option key={p._id} value={p._id}>
                {p.projectName}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="chat_main">
        {/* ── NO PROJECT SELECTED ─────────────────────────────────────── */}
        {!projectId ? (
          <div className="ya-no-project">
            <span className="ya-no-project__icon">📁</span>
            <h4>No project selected</h4>
            <p>Please select a project from the dropdown above to get started.</p>
          </div>
        ) : (
          <>
            {/* ── TABS ────────────────────────────────────────────────── */}
            <div className="ya-tabs">
              <button
                className={`ya-tab ${activeTab === "assess" ? "ya-tab--active" : ""}`}
                onClick={() => setActiveTab("assess")}
              >
                🏥 Quick Assess
              </button>
              {/* <button
                className={`ya-tab ${activeTab === "chat" ? "ya-tab--active" : ""}`}
                onClick={() => setActiveTab("chat")}
              >
                💬 AI Chat
              </button> */}
            </div>

            {/* ── QUICK ASSESS TAB ────────────────────────────────────── */}
            {activeTab === "assess" && (
              <div className="ya-assess-tab">
                <QuickAssessPanel
                  projectId={projectId}
                  projectName={currentProject?.projectName}
                  onAssessmentComplete={handleAssessmentComplete}
                />

                {isClinicalLoading && (
                  <div className="clinical-loading">
                    <div className="clinical-loading__spinner" />
                    <p>Loading previous assessment…</p>
                  </div>
                )}

                {reviewStatus === "approved" && nextSteps && (
                  <div className="clinical-post-action clinical-post-action--approved">
                    <div className="clinical-post-action__header">
                      <span className="clinical-post-action__icon">✓</span>
                      <span className="clinical-post-action__title">Treatment Plan Approved</span>
                    </div>
                    <p className="clinical-post-action__msg">{nextSteps.message}</p>
                    {nextSteps.clinicalNotes && (
                      <div className="clinical-post-action__notes">
                        <p className="clinical-post-action__notes-label">Copy-paste clinical note</p>
                        <pre className="clinical-post-action__notes-text">
                          {nextSteps.clinicalNotes}
                        </pre>
                        <button
                          className="clinical-post-action__copy-btn"
                          onClick={() => {
                            navigator.clipboard.writeText(nextSteps.clinicalNotes);
                            const btn = document.querySelector(".clinical-post-action__copy-btn");
                            if (btn) {
                              btn.textContent = "Copied!";
                              setTimeout(() => {
                                btn.textContent = "Copy note";
                              }, 2000);
                            }
                          }}
                        >
                          Copy note
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {reviewStatus === "rejected" && nextSteps && (
                  <div className="clinical-post-action clinical-post-action--rejected">
                    <div className="clinical-post-action__header">
                      <span className="clinical-post-action__icon">✕</span>
                      <span className="clinical-post-action__title">Assessment Rejected</span>
                    </div>
                    <p className="clinical-post-action__msg">{nextSteps.message}</p>
                  </div>
                )}
              </div>
            )}

            {/* ── CHAT TAB ────────────────────────────────────────────── */}
            {activeTab === "chat" && (
              <>
                <div className="scroll_content" ref={chatContainerRef}>
                  {chatData.length === 0 && !loading && (
                    <div className="ya-chat-empty">
                      <span className="ya-chat-empty__icon">💬</span>
                      <h4>Ask anything about uploaded documents</h4>
                      <p>
                        Upload patient documents using the <strong>＋</strong> button below, then
                        ask questions.
                      </p>
                    </div>
                  )}

                  {chatData.length > 0 &&
                    chatData
                      .slice()
                      .reverse()
                      .map((message, index) => {
                        const displayText =
                          message?.answerText || message?.matchingText || "I don't know.";
                        const dataForPdf =
                          message?.matchingText || message?.answerText || "I don't know.";
                        const matchingChat = currentProject?.ProjectChat.find(
                          (c) => c._id === message.projectChatId
                        );
                        const pdfName = matchingChat?.chatName || null;
                        const pdfLink = ApiBaseUrl + "/pdf/" + matchingChat?.pdf || "#";
                        const isStructured = !!(
                          message?.answerText ||
                          message?.reasoning ||
                          message?.followUpQuestions
                        );
                        const isLastMessage = index === chatData.length - 1;
                        return (
                          <div className="content" key={index}>
                            <div className="conversation">
                              <div className="message">
                                <div className="message_content">
                                  <div className="user_chat">
                                    <p>{message.request}</p>
                                  </div>
                                  <p
                                    style={{
                                      color: "#636363",
                                      fontWeight: "500",
                                      fontSize: "11px",
                                      lineHeight: 1.4,
                                    }}
                                  >
                                    {moment(message.createdAt).fromNow()}
                                  </p>
                                </div>
                                <div className="message-meta">
                                  <img src={ai_icon_new} alt="ai" className="ai_icon_new" />
                                  <span className="ai_contents">
                                    <div style={{ whiteSpace: "pre-wrap", lineHeight: "24px" }}>
                                      {isStructured ? (
                                        <FormatResponse
                                          message={message}
                                          onFollowUpClick={handleFollowUpClick}
                                          isLastMessage={isLastMessage}
                                        />
                                      ) : (
                                        <FormatResponse text={displayText} />
                                      )}
                                    </div>
                                    {(pdfName ||
                                      (message?.disclaimer &&
                                        message.disclaimer.length > 0)) && (
                                      <div className="chat-bottom-bar">
                                        {pdfName && isProdjectWithPdf && (
                                          <div className="chat-pdf-name">
                                            <span
                                              onClick={() =>
                                                handlePdfLinkClick(
                                                  pdfLink,
                                                  dataForPdf,
                                                  message._id,
                                                  dataForPdf
                                                )
                                              }
                                            >
                                              {pdfName}
                                            </span>
                                          </div>
                                        )}
                                        {message?.disclaimer &&
                                          message.disclaimer.length > 0 && (
                                            <DisclaimerIcon disclaimer={message.disclaimer} />
                                          )}
                                      </div>
                                    )}
                                  </span>
                                  <div
                                    className="day_img"
                                    onClick={() =>
                                      navigator.clipboard.writeText(message.response)
                                    }
                                  >
                                    <img src={copy_icon} alt="copy" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                  {loading && (
                    <div className="content">
                      <div className="conversation">
                        <div className="message">
                          {question1 && (
                            <div className="message_content">
                              <div className="user_chat">
                                <p>{question1}</p>
                              </div>
                            </div>
                          )}
                          <div className="message-meta">
                            <img src={ai_icon_new} alt="ai" className="ai_icon_new" />
                            <span className="ai_contents ai-typing-bubble">
                              <span className="typing-dots">
                                <span />
                                <span />
                                <span />
                              </span>
                              <span className="typing-label">Analysing documents</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {isPdfViewerOpen && (
                    <PdfViewer
                      pdfUrl={currentPdfContext.pdfUrl}
                      questionId={currentPdfContext.questionId}
                      onClose={closePdfViewer}
                      isOpen={isPdfViewerOpen}
                    />
                  )}
                </div>

                <div className="input-area">
                  <div className="pdf_file">
                    <img
                      src={add_circle}
                      alt="add"
                      className="add_circle"
                      onClick={() => setShowOptionList(!showOptionList)}
                      style={{ cursor: "pointer" }}
                    />
                    {showOptionList && (
                      <div className="document-optionlist">
                        <div className="document-option-item">
                          <h4 className="upload-title">Upload Document</h4>
                          <PdfFileUpload
                            projectId={projectId}
                            setShowOptionList={setShowOptionList}
                            onPdfUploadSuccess={handlePdfUploadSuccess}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Ask a question about uploaded documents…"
                    value={question}
                    onChange={(e) => {
                      setQuestion(e.target.value);
                      setQuestion1(e.target.value);
                    }}
                    disabled={loading}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") onSendMessage();
                    }}
                  />
                  <img
                    src={send_icon}
                    style={{ cursor: "pointer" }}
                    alt="send"
                    className="send_icon"
                    onClick={onSendMessage}
                  />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default YourAi;